import { ProfilesOptionsProfileVisibility } from "PFCore/services/profile";
import { Id } from "PFTypes";

export enum SearchEntity {
  Role = "role",
  AuditRole = "audit_role",
  Engagement = "engagement",
  AuditEngagement = "audit_engagement",
  Profile = "profile"
}

export type EntityConfig = {
  entity: SearchEntity;
  useAsTerm?: boolean;
  redirect?: boolean;
  hiddenEntities?: Id[];
  perPage?: number;
  owned?: boolean;
  state?: string[];
  profileVisibility?: ProfilesOptionsProfileVisibility;
  matchedProfileId?: Id;
};

export type SearchConfig = EntityConfig[];

export type SearchEntityData = {
  id: Id;
  type: SearchEntity;
};

export type SearchDropdownItem = {
  text: string;
  entity?: SearchEntityData;
  useAsTerm?: boolean;
  keepOpenOnSelect?: boolean;
  onClick?: (term?: string, entity?: SearchEntityData) => void;
};
